import { IFieldDef } from "@components/smart/FieldInfo";
import { ISmartFieldRenderProps } from "@components/smart/smartField/SmartField";
import { createDateFromPeriod, TPayrollPeriod } from "@pages/payroll/payroll.utils";
import { SmartFastEntryListStyled } from "@pages/payroll/submission/Submission.styles";
import { sortCompareFn } from "@utils/general";
import React from "react";

import { FormStorage } from "../../../../views/formView/FormStorage";

interface IProps extends ISmartFieldRenderProps {
    groupDefinitionId: string;
    columns?: IFieldDef[];
}

export const SummaryRowId = Infinity;
export const SortKey = "##SortKey##";

// Sorts the periods in ascending order and creates a unique key for each period, which is used for rendering in the SmartFastEntryList.
export function sortPeriodsAndCreateKey<T extends TPayrollPeriod>(periods: T[]): (T & { [SortKey]: number })[] {
    let order = 0;
    periods.sort((a, b) => {
        if (a.Id === SummaryRowId) {
            return 1;
        }
        if (b.Id === SummaryRowId) {
            return -1;
        }
        return sortCompareFn(createDateFromPeriod(a), createDateFromPeriod(b));
    });
    return (periods as (T & { [SortKey]: number })[]).map(p => {
        p[SortKey] = order++;
        return p;
    });
}

const DecisivePeriodsSmartFastEntryList: React.FC<IProps> = ({
                                                                 parentProps,
                                                                 groupDefinitionId,
                                                                 value,
                                                                 columns
                                                             }) => {
    const storage = parentProps.storage as FormStorage;
    const { bindingContext, onChange, onBlur } = parentProps;

    return (
        <SmartFastEntryListStyled
            groupId={groupDefinitionId}
            storage={storage}
            bindingContext={bindingContext}
            useLabelWrapping
            disableVirtualization
            canAdd={false}
            isItemRemovable={false}
            isItemCloneable={false}
            onChange={onChange}
            onBlur={onBlur}
            columns={columns}
            order={SortKey}
        />
    );
};

export default DecisivePeriodsSmartFastEntryList;